import React from 'react';
import { ArrowLeft, Mail, Phone, MapPin } from 'lucide-react';
import { Button } from './ui/button';

export const Impressum = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="container mx-auto px-4 max-w-4xl">
        <Button
          onClick={() => window.history.back()}
          variant="outline"
          className="mb-8"
          data-testid="impressum-back-btn"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Zurück
        </Button>

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-atob-blue mb-8">Impressum</h1>

          <div className="space-y-8 text-gray-700">
            {/* Company Info */}
            <section>
              <h2 className="text-2xl font-bold text-atob-blue mb-4">Angaben gemäß § 5 DDG</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-lg font-bold text-atob-blue mb-2">AtoB Objektservice GmbH</p>
                <p className="mb-1">Schneiderstraße 63</p>
                <p className="mb-4">40764 Langenfeld</p>
                <p className="mb-1">Deutschland</p>
              </div>
            </section>

            {/* Legal Representative */}
            <section>
              <h2 className="text-2xl font-bold text-atob-blue mb-4">Vertreten durch</h2>
              <p className="mb-2"><strong>Geschäftsführer:</strong></p>
              <ul className="list-disc list-inside space-y-1 ml-2">
                <li>Admir Basic</li>
                <li>Guiseppe Alessandro Costantino (einzelvertretungsberechtigt)</li>
              </ul>
            </section>

            {/* Contact */}
            <section>
              <h2 className="text-2xl font-bold text-atob-blue mb-4">Kontakt</h2>
              <div className="space-y-3">
                <div className="flex items-start space-x-3">
                  <Phone className="h-5 w-5 text-atob-orange mt-1" />
                  <div>
                    <p className="font-semibold">Telefon:</p>
                    <p className="text-sm text-gray-500 mt-1">Büro (Festnetz):</p>
                    <a href="tel:+4921732046452" className="hover:text-atob-orange transition-colors">
                      +49 2173 204 6452
                    </a>
                    <p className="text-sm text-gray-500 mt-2">Mobil:</p>
                    <a href="tel:+4915151488980" className="hover:text-atob-orange transition-colors">
                      +49 151 51488980
                    </a>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <Mail className="h-5 w-5 text-atob-orange" />
                  <div>
                    <p className="font-semibold">E-Mail:</p>
                    <a href="mailto:info@atob-objektservice.de" className="hover:text-atob-orange transition-colors">
                      info@atob-objektservice.de
                    </a>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <MapPin className="h-5 w-5 text-atob-orange mt-1" />
                  <div>
                    <p className="font-semibold">Adresse:</p>
                    <p>Schneiderstraße 63</p>
                    <p>40764 Langenfeld</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Register Entry */}
            <section>
              <h2 className="text-2xl font-bold text-atob-blue mb-4">Registereintrag</h2>
              <div className="bg-gray-50 p-6 rounded-lg space-y-1">
                <p><strong>Eintragung im Handelsregister</strong></p>
                <p>Registergericht: Amtsgericht Düsseldorf</p>
                <p>Registernummer: HRB 113625</p>
                <p>Stammkapital: 25.000,00 EUR</p>
              </div>
            </section>

            {/* VAT ID */}
            <section>
              <h2 className="text-2xl font-bold text-atob-blue mb-4">Umsatzsteuer-ID</h2>
              <p className="mb-2">
                Eine Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz
                liegt derzeit nicht vor und wird nach Erteilung durch das Finanzamt hier
                nachgetragen.
              </p>
            </section>

            {/* Responsible for content */}
            <section>
              <h2 className="text-2xl font-bold text-atob-blue mb-4">
                Redaktionell verantwortlich (§ 18 Abs. 2 MStV)
              </h2>
              <p className="mb-1">Admir Basic</p>
              <p className="mb-1">AtoB Objektservice GmbH</p>
              <p className="mb-1">Schneiderstraße 63</p>
              <p>40764 Langenfeld</p>
            </section>

            {/* EU Dispute Resolution */}
            <section>
              <h2 className="text-2xl font-bold text-atob-blue mb-4">EU-Streitschlichtung</h2>
              <p className="mb-4">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
              </p>
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-atob-orange hover:underline break-all"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              <p className="mt-4">
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </section>

            {/* Consumer Dispute Resolution */}
            <section>
              <h2 className="text-2xl font-bold text-atob-blue mb-4">
                Verbraucherstreitbeilegung / Universalschlichtungsstelle
              </h2>
              <p className="mb-4">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            {/* Liability for Content */}
            <section>
              <h2 className="text-2xl font-bold text-atob-blue mb-4">Haftung für Inhalte</h2>
              <p className="mb-4">
                Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen
                Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind
                wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte
                fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
                rechtswidrige Tätigkeit hinweisen.
              </p>
              <p className="mb-4">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach
                den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung
                ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
                möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir
                diese Inhalte umgehend entfernen.
              </p>
            </section>

            {/* Liability for Links */}
            <section>
              <h2 className="text-2xl font-bold text-atob-blue mb-4">Haftung für Links</h2>
              <p className="mb-4">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir
                keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine
                Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
                Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden
                zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige
                Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
                inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte
                einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen
                werden wir derartige Links umgehend entfernen.
              </p>
            </section>

            {/* Copyright */}
            <section>
              <h2 className="text-2xl font-bold text-atob-blue mb-4">Urheberrecht</h2>
              <p className="mb-4">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
                unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
                Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
                bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen
                Gebrauch gestattet.
              </p>
            </section>

            {/* Footer */}
            <div className="mt-12 pt-8 border-t border-gray-200 text-sm text-gray-600">
              <p>Stand: Februar 2026</p>
              <p className="mt-2">
                Erstellt gemäß Digitale-Dienste-Gesetz (DDG) und Medienstaatsvertrag (MStV).
              </p>
            </div>
          </div>
        </div>

        <Button
          onClick={scrollToTop}
          className="mt-8 bg-atob-orange hover:bg-atob-orange/90 text-white"
          data-testid="impressum-scroll-top-btn"
        >
          Nach oben
        </Button>
      </div>
    </div>
  );
};
